// index.js
export const changeScreenWidth = (width) => {
  return {
    type: 'CHANGE_SCREEN_WIDTH',
    screenWidth: width,
  };
};

export const changeScreenHeight = (height) => {
  return {
    type: 'CHANGE_SCREEN_HEIGHT',
    screenWidth: height,
  };
};


export {
  top,
  dashboard,
  result,
} from './navigater';

export {
  LOGIN,
  login,
} from './login';

export {
  EMOTION,
  getEmotion,
} from './analyze';
